import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { Label } from '@/components/ui/label';
import { Input } from '@/components/ui/input';
import { Textarea } from '@/components/ui/textarea';
import { RadioGroup, RadioGroupItem } from '@/components/ui/radio-group';
import { Checkbox } from '@/components/ui/checkbox';
import { LOCATIONS } from '@/lib/education-levels';
import { CreateTemplateFormData } from './types';

interface StepOtherProps {
  formData: CreateTemplateFormData;
  updateFormData: (updates: Partial<CreateTemplateFormData>) => void;
}

export function StepOther({ formData, updateFormData }: StepOtherProps) {
  return (
    <div className="space-y-6">
      <Card>
        <CardHeader>
          <CardTitle className="text-lg">สาขา</CardTitle>
        </CardHeader>
        <CardContent>
          <RadioGroup
            value={formData.location}
            onValueChange={(v) => updateFormData({ location: v })}
            className="flex gap-6"
          >
            {LOCATIONS.map((loc) => (
              <div key={loc.value} className="flex items-center space-x-2">
                <RadioGroupItem value={loc.value} id={`location-${loc.value}`} />
                <Label htmlFor={`location-${loc.value}`} className="cursor-pointer">
                  {loc.label}
                </Label>
              </div>
            ))}
          </RadioGroup>
        </CardContent>
      </Card>

      <Card>
        <CardHeader>
          <CardTitle className="text-lg">ห้องเรียน</CardTitle>
        </CardHeader>
        <CardContent>
          <Input
            placeholder="เช่น A101, ห้อง 2"
            value={formData.room_name}
            onChange={(e) => updateFormData({ room_name: e.target.value })}
          />
          <p className="text-xs text-muted-foreground mt-2">ไม่บังคับ</p>
        </CardContent>
      </Card>

      <Card>
        <CardHeader>
          <CardTitle className="text-lg">คลาสพิเศษ</CardTitle>
        </CardHeader>
        <CardContent className="space-y-4">
          <div className="flex items-center space-x-2">
            <Checkbox
              id="is_special_class"
              checked={formData.is_special_class}
              onCheckedChange={(checked) => 
                updateFormData({ 
                  is_special_class: !!checked,
                  fixed_cost: checked ? formData.fixed_cost : null 
                })
              }
            />
            <Label htmlFor="is_special_class" className="cursor-pointer">
              เป็นคลาสพิเศษ (กำหนดค่าสอนเอง)
            </Label>
          </div>

          {formData.is_special_class && (
            <div>
              <Label>ค่าสอนต่อชั่วโมง (บาท)</Label>
              <Input
                type="number"
                placeholder="500"
                className="mt-1.5 w-48"
                value={formData.fixed_cost ?? ''}
                onChange={(e) => 
                  updateFormData({ 
                    fixed_cost: e.target.value ? Number(e.target.value) : null 
                  })
                }
              />
            </div>
          )}
        </CardContent>
      </Card>

      <Card>
        <CardHeader>
          <CardTitle className="text-lg">หมายเหตุ</CardTitle>
        </CardHeader>
        <CardContent>
          <Textarea
            placeholder="หมายเหตุเพิ่มเติม..."
            value={formData.note}
            onChange={(e) => updateFormData({ note: e.target.value })}
            rows={4}
          />
        </CardContent>
      </Card>
    </div>
  );
}
